<script setup lang="ts">
import { Badge } from '@/Components/ui/badge'
import { Users, Video, CheckCircle2 } from 'lucide-vue-next'

interface Props {
  tutor: {
    avatar: string
    name: string
    highlight: string
    is_verified: boolean
    students_count: number
    videos_count: number
  }
}

const props = defineProps<Props>()
</script>

<template>
  <section class="bg-white md:rounded-2xl shadow-sm overflow-hidden">
    <div class="relative h-32 md:h-64 bg-gradient-to-br from-teal-50 to-blue-50">
      <div class="absolute inset-0 opacity-10">
        <div class="absolute top-10 left-10 w-32 h-32 bg-teal-500 rounded-full blur-3xl" />
        <div class="absolute bottom-10 right-10 w-40 h-40 bg-blue-500 rounded-full blur-3xl" />
      </div>
    </div>
    <div class="relative px-8 pb-8">
      <div class="flex flex-col md:flex-row items-center md:items-end -mt-20">
        <img
          :src="tutor.avatar"
          :alt="tutor.name"
          class="w-40 h-40 rounded-2xl border-4 border-white shadow-xl"
        >
        <div class="text-center md:text-left mt-6 md:mt-0 md:ml-6 mb-4">
          <div class="flex max-sm:justify-center gap-3 mb-2">
            <h1 class="text-2xl md:text-3xl font-bold text-gray-900">{{ tutor.name }}</h1>
            <Badge v-if="tutor.is_verified" class="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium flex items-center gap-1">
              <CheckCircle2 class="w-4 h-4" />
              Verified
            </Badge>
          </div>
          <p class="text-base md:text-lg text-gray-600 mb-3">{{ tutor.highlight }}</p>
          <div class="flex flex-col md:flex-row items-center gap-2 md:">
            <!-- <div class="flex items-center text-gray-600">
              <Users class="w-5 h-5 mr-2" />
              <span class="font-medium">{{ tutor.students_count.toLocaleString() }} students</span>
            </div> -->
            <div class="flex items-center text-gray-600">
              <Video class="w-5 h-5 mr-2" />
              <span class="font-medium">{{ tutor.videos_count }} videos</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
